import { Grid, Menu, MenuItem, Tooltip, Typography, makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import MoreVertIcon from '@material-ui/icons/MoreVert';
import dayjs from 'dayjs';
import BlueprintCloneDialog from '../../molecules/dialogs/BlueprintCloneDialog';
import BlueprintExportDialog from '../../molecules/dialogs/BlueprintExportDialog';
import BlueprintDeleteDialog from '../../molecules/dialogs/BlueprintDeleteDialog';
import BlueprintEditDialog from '../../molecules/dialogs/BlueprintEditDialog';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { handleTopRightInfo } from '../../../store/global/actions';
import { formatFetchedCustomIcons, formatGeneratedIconSourePath } from '../../../utils/commonUtils';

const useStyles = makeStyles(() => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    background: '#ffffff',
    boxShadow: '0px 0px 10px rgba(0,0,0,0.05)',
    borderRadius: '14px',
    padding: '1rem',
    justifyContent: 'space-between',
    minWidth: '100%',
    userSelect: 'none',
    cursor: 'pointer',
    position: 'relative',
    // cursor: 'pointer',
    transition: 'transform 0.3s ease-in-out, background-color 0.3s ease-in-out', // Add transition for smooth effect
    '&:hover': {
      transform: 'scale(1.02)', // Add zoom effect
      //backgroundColor: '#f0f0f0', // Change background color on hover
    },
  },
  titleOption: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem'
  },
  cardBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
    
  },
  dateText: {
    marginTop: '20px',
    color: '#6B6B6B'
  },
  sharedByTag: {
    background: "#364150",
    padding: '3px 1rem',
    borderRadius: '50px',
    color: '#fff',
    width: 'max-content',
    marginTop: '1rem'
  },
  card_icon_container: {
    position: 'absolute',
    width: '40px',
    height: '40px',
    bottom: '1rem',
    right: '1rem'
  },
  card_icon: {
    width: '100%',
    height: '100%',
  }
}))

export default function BlueprintCards({ data, isOwnBlueprint}) {
  
  const iconPath = `/blueprintAssets/${data?._id}_${data?.slug}/`
  const [options, setOptions] = useState(['Open', 'Clone', 'Export', 'Edit', 'Delete'])
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeDialog, setActiveDialog] = useState(null);
  const [selectedItem, setSelectedItem] = useState(data);
  const [iconSource, setIconSource] = useState(formatFetchedCustomIcons(data, iconPath));


  const handleChooseOption = (event, option) => {
    event.stopPropagation();
    // console.log('Option choosing', option)
    switch (option) {
      case 'Open':
        dispatch(handleTopRightInfo({ message: "Opening blueprint..", open: true, }));
        history.push(`/blueprint/${data?.slug}/${data?._id}/system-model`)
        break;
      case 'Clone':
        setActiveDialog('clone')
        break;
      case 'Export':
        setActiveDialog('export')
        break;
      case 'Delete':
        setActiveDialog('delete')
        break;
      case 'Edit':
        setActiveDialog('edit')
        break;
      case 'Share':
        history.push(`/blueprint/${data?.slug}/${data?._id}/teams`)
        break;

      default:
        setActiveDialog(null)
        break;
    }

    setAnchorEl(null)
  }

  const handleOpenOption = (event) => {
    event.stopPropagation();
    setAnchorEl(event.target);
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }
  

  useEffect(() => {
    // if (isOwnBlueprint) {
    //   setOptions(['Open', 'Clone', 'Export', 'Edit', 'Delete', 'Share'])
    // } else {
    //   setOptions([['Open', 'Clone', 'Export']])
    // }

    if (data != undefined && data.bpOwner != undefined && data.accessLevel != undefined && data.accessLevel == "VIEWER" ) {
      setOptions(['Open', 'Clone', 'Export'])
    } else {
      setOptions(['Open', 'Clone', 'Export', 'Edit', 'Delete', 'Share'])
    }
  }, [isOwnBlueprint, data]);


  useEffect(() => {
    setIconSource(formatFetchedCustomIcons(selectedItem, iconPath))
  }, [selectedItem])

  const openBluepintCard = (e) => {
    e.stopPropagation();
    if (anchorEl == null && e?.target?.dataset?.identifier === "blueprint_card") {
      dispatch(handleTopRightInfo({ message: "Opening blueprint..", open: true, }));
      history.push(`/blueprint/${data?.slug}/${data?._id}/system-model`)
    }

  }


  return (
    <div className={`${classes.card} blueprint_card blueprint-card-${data?.name}`} id={data?.slug} data-identifier="blueprint_card" onClick={(event) => openBluepintCard(event)}>
      {
        activeDialog === 'clone' ?
          <BlueprintCloneDialog isOpen={true} setActiveDialog={setActiveDialog} selectedItem={data} />
          : activeDialog === 'export' ?
            <BlueprintExportDialog isOpen={true} setActiveDialog={setActiveDialog} selectedItem={data} />
            : activeDialog === 'delete' ?
              <BlueprintDeleteDialog isOpen={true} setActiveDialog={setActiveDialog} selectedItem={data || selectedItem} />
              : activeDialog === 'edit' ?
                <BlueprintEditDialog blueprint_id={data?._id} slug={data?.slug} setIconSource={setIconSource}   isOpen={true} setActiveDialog={setActiveDialog} selectedItem={data || selectedItem} setSelectedItem={setSelectedItem}/>
                : null
      }
      <div style={{pointerEvents: 'none'}}>
        <Grid className={classes.titleOption} styles={{pointerEvents: 'none'}}>
          <Tooltip title={data?.name}>
            <Typography styles={{pointerEvents: 'none', pointerEvents: 'none'}} variant='h6' style={{ overflow: 'hidden', textOverflow: 'ellipsis', cursor: 'pointer' }}>{data?.name}</Typography>
          </Tooltip>
          <Tooltip title='Options'>
            <MoreVertIcon style={{ cursor: 'pointer',pointerEvents: 'all' }} onClick={(event) => handleOpenOption(event)} />
          </Tooltip>
          <Menu
            id="blueprintOptions"
            anchorEl={anchorEl}
            keepMounted
            open={anchorEl}
            onClose={handleMenuClose}
            MenuListProps={{ id: `blueprint_${data?.name}_card` }}
            PaperProps={{
              style: {
                maxHeight: '100%',
                width: '20ch',
              },
            }}
          >
            {options.map((option) => (
              <MenuItem key={option} onClick={(event) => handleChooseOption(event, option)}>
                {option}
              </MenuItem>
            ))}
          </Menu>
        </Grid>
        <div className={classes.cardBody} onClick={(event) => openBluepintCard(event)} style={{ cursor: 'pointer' }}>
          {
            (data?.description && data?.description !== '') &&
            <Typography>{data?.description}</Typography>
          }

          <Typography className={classes.dateText}>Last updated on {dayjs(data.updatedAt).format("YYYY-MM-DD hh:mm A")}</Typography>
          
        </div>
      </div >
      {
        data?.bpOwner &&
        <Typography className={classes.sharedByTag}>Shared by {data?.bpOwner?.firstName} {data?.bpOwner?.lastName}</Typography>
      }

      {/* Show icon in the card */}
      { iconSource && iconSource != "" && (
        <div className={`${classes.card_icon_container} card-icon-container`}>
            <img className={`${classes.card_icon} card-icon`} alt="Icon" src={formatGeneratedIconSourePath(iconSource)}/>
        </div>
      )}

    </div>
  )
}
